'use client'

import { logger } from '@/lib/logger'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    // Gửi error tới Sentry để theo dõi và debug
    logger.captureException(error as Error)
  }, [error])

  return (
    <div className='flex min-h-[400px] flex-col items-center justify-center'>
      <h2 className='mb-4 text-xl font-semibold'>
        Đã có lỗi xảy ra khi tải thông tin
      </h2>
      <button
        onClick={reset}
        className='rounded-md bg-primary px-4 py-2 text-white'
      >
        Thử lại
      </button>
    </div>
  )
}
